var config = require('../config.js')
module.exports = {
    realNameAdd: config.host + '/tktinc/api/v1/real-name/add/c', // 添加观演人实名
    realNameDelete: config.host + '/tktinc/api/v1/real-name/delete/c', // 删除观演人实名
    realNameList: config.host + '/tktinc/api/v1/real-name/list/c', // 观演人实名列表

}